// extracted by mini-css-extract-plugin
module.exports = {"textArea":"InputBlock_textArea___0lQ5","container":"InputBlock_container___mUgx"};